import React from 'react';
import { getMarketplaceProductByCategory } from '../../utils/serviceRouting';

/**
 * Ícono/imagen homologado de un servicio de marketplace, tomado del catálogo
 * (`logoSrc` + `colorScheme`). Misma imagen que se ve en el Marketplace.
 * Úsalo en el header de los detalles: <ServiceLogo category="WORDPRESS" />.
 * Si el producto no tiene logo, cae a las iniciales sobre el color del producto.
 */

interface ServiceLogoProps {
  /** apiCategory del producto, ej. "WORDPRESS", "SQLSERVER_EXPRESS". */
  category?: string | null;
  className?: string;
}

const ServiceLogo: React.FC<ServiceLogoProps> = ({ category, className }) => {
  const product = getMarketplaceProductByCategory(category);
  const bg = product?.colorScheme?.bg || 'bg-gray-100 dark:bg-gray-800';
  const text = product?.colorScheme?.text || 'text-gray-600 dark:text-gray-300';
  const initials = (product?.name || category || '?').trim().slice(0, 2).toUpperCase();

  return (
    <div
      className={`w-full h-full rounded-lg ${bg} flex items-center justify-center overflow-hidden ${className || ''}`}
    >
      {product?.logoSrc ? (
        <img
          src={product.logoSrc}
          alt={product.name}
          className="w-3/4 h-3/4 object-contain"
        />
      ) : (
        <span className={`text-sm font-bold ${text}`}>{initials}</span>
      )}
    </div>
  );
};

export default ServiceLogo;
